// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__14x-r","upload":"Small_upload__37BSY","imageWrap":"Small_imageWrap__1ZHLg","removeBtn":"Small_removeBtn__3UeJk"};